import React, { createContext, useContext, ReactNode } from 'react';
import { storageWrapper } from '../services/StorageWrapper';

type StorageContextType = typeof storageWrapper;

const StorageContext = createContext<StorageContextType | undefined>(undefined);

interface StorageProviderProps {
  children: ReactNode;
}

export const StorageProvider: React.FC<StorageProviderProps> = ({ children }) => {
  return (
    <StorageContext.Provider value={storageWrapper}>
      {children}
    </StorageContext.Provider>
  );
};

export const useStorage = () => {
  const context = useContext(StorageContext);
  if (context === undefined) {
    throw new Error('useStorage must be used within a StorageProvider');
  }
  return context;
}; 